module.exports = __webpack_public_path__ + "img/2000.8831d153.jpg";